import { forwardRef, type Ref, type SVGProps } from "react";

function SvgArrowUpRightFromSquare(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16" {...props}>
      <g clipPath="url(#a)">
        <path
          fill="currentColor"
          d="M10 .75c0 .416.334.75.75.75h3.19L6.97 8.469a.75.75 0 0 0 1.06 1.06l6.968-6.97L15 5.75c0 .416.334.75.75.75s.75-.334.75-.75v-5a.75.75 0 0 0-.75-.75h-5a.75.75 0 0 0-.75.75M2.75 1A2.25 2.25 0 0 0 .5 3.25v10.5A2.25 2.25 0 0 0 2.75 16h10.5a2.25 2.25 0 0 0 2.25-2.25v-4a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v4c0 .416-.334.75-.75.75H2.75a.75.75 0 0 1-.75-.75V3.25c0-.416.334-.75.75-.75h4c.416 0 .75-.334.75-.75A.75.75 0 0 0 6.75 1z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M.5 0h16v16H.5z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowUpRightFromSquare);
export default ForwardRef;
